import React from 'react';

import QuestionHOC from './QuestionHOC';

export default function Allergies({ item, index }) {
  const displayQuestion = () => {
    if (item.hasOwnProperty('onlyAnswer') && item.onlyAnswer === true) {
      return <div className="col">None</div>
    } else {
      return <>
        <div className="col-8">Allergies</div>
        <div className="col-4">None</div>
      </>
    }
  }

  return <QuestionHOC item={item} index={index}>
    <div className="row">
      {displayQuestion()}
    </div>
  </QuestionHOC>
}